import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=4a2fe7f7&scoped=true&lang=pug&"
import script from "./HelpPanel.vue?vue&type=script&lang=js&"
export * from "./HelpPanel.vue?vue&type=script&lang=js&"
import style0 from "./HelpPanel.vue?vue&type=style&index=0&id=4a2fe7f7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2fe7f7",
  null
  
)

export default component.exports